export default __webpack_public_path__ + "static/media/logo-symbol-dark.4e1d9dd5.svg";